import request from "@/utils/request";
import store from "@/store/index";
import { getModelEditStatus, deleteAxisMeasureAndroid } from "@/api/androidApi";

// 模型保存
export function importModel(data) {
  return request({
    url: `/api/${store.state.app.version_api}/importModel`,
    method: "post",
    data,
  });
}

// 上传文件
export function upload(data) {
  return request({
    url: "/api/v1/upload",
    method: "post",
    data,
  });
}
// 上传文件
export function Repupload(data) {
  return request({
    url: "/common/upload",
    method: "post",
    data,
  });
}
// 上传报告文件
export function uploadString(data) {
  return request({
    url: "api/v1/common/uploadString",
    method: "post",
    data,
  });
}

// 芯样强度导入
export function croingStrengthImport(data) {
  return request({
    url: "/api/v1/croingStrengthImport",
    method: "post",
    data,
  });
}
//取芯-导入
export function croingStrengthReportImport(data) {
  return request({
    url: "/api/v1/croingStrengthReportImport",
    method: "post",
    data,
  });
}

//模型导出
export function exportData(params) {
  return request({
    // url: "/api/v1/cad/exportData",
    url: `/api/${store.state.app.version_api}/exportModel`,
    method: "get",
    params,
  });
}

//获取模型状态
export function modelEditStatus(params) {
  if (store.state.app.isAndroid) {
    return getModelEditStatus(params);
  }
  return request({
    url: `/api/${store.state.app.version_api}/modelEditStatus`,
    method: "get",
    params,
  });
}
// 保存计算书
export function importCalculate(data) {
  return request({
    url: `/api/${store.state.app.version_api}/importCalculate`,
    method: "post",
    data,
  });
}

// 计算书展示
export function getCalculateList(params) {
  return request({
    url: `api/v1/Appraisal/Calculate/list`,
    method: "get",
    params,
  });
}
// dwg编号上传匹配墙out文件
export function importOutCalculate(data) {
  return request({
    url: `/api/${store.state.app.version_api}/importOutCalculate`,
    method: "post",
    data,
  });
}

//删除轴线测量数据
export function deleteAxisMeasure(data) {
  if (store.state.app.isAndroid) {
    return deleteAxisMeasureAndroid(data);
  }
  return request({
    url: `/api/v1/axisDelete`,
    method: "delete",
    data,
  });
}
//保存楼板验算结果数据
export function saveSlabCalData(data) {
  return request({
    url: `/api/${store.state.app.version_api}/importDwgCalculate`,
    method: "post",
    data,
  });
}
